// A single source of truth shared by the bootstrap and React ThemeProvider.
export const THEME_STORAGE_KEY = "theme";
const DARK_QUERY = "(prefers-color-scheme: dark)";

export function getThemePreference() {
  try {
    const saved = window.localStorage.getItem(THEME_STORAGE_KEY);
    return saved === "light" || saved === "dark" ? saved : "system";
  } catch {
    return "system"; // Storage is unavailable in some private/browser modes.
  }
}

export function saveThemePreference(mode) {
  try {
    if (mode === "system") window.localStorage.removeItem(THEME_STORAGE_KEY);
    else window.localStorage.setItem(THEME_STORAGE_KEY, mode);
  } catch {
    // The current tab still respects the selected mode without persistence.
  }
}

export function systemPrefersDark() {
  return typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia(DARK_QUERY).matches;
}

export function resolveDarkMode(mode = getThemePreference()) {
  return mode === "dark" || (mode === "system" && systemPrefersDark());
}

export function applyThemeToDocument(isDark) {
  if (typeof document === "undefined") return;
  const mode = isDark ? "dark" : "light";
  document.documentElement.classList.toggle("dark", isDark);
  document.documentElement.classList.toggle("light", !isDark);
  document.documentElement.setAttribute("data-theme", mode);
  document.documentElement.style.colorScheme = mode;
  if (document.body) {
    document.body.classList.toggle("dark", isDark);
    document.body.classList.toggle("light", !isDark);
  }
  let meta = document.querySelector('meta[name="theme-color"]');
  if (!meta && document.head) {
    meta = document.createElement("meta");
    meta.setAttribute("name", "theme-color");
    document.head.appendChild(meta);
  }
  meta?.setAttribute("content", isDark ? "#111827" : "#ffffff");
}
